
import React, { useEffect } from 'react';
import PriceCalculator from '@/components/PriceCalculator';

const Index = () => {
  // Clear localStorage and sessionStorage when the main page loads
  useEffect(() => {
    localStorage.clear();
    sessionStorage.clear();
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-blue-50 to-blue-100">
      {/* Header */}
      <header className="w-full py-8 md:py-12 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex justify-center mb-6">
            <img 
              src="/logos/17592c35-a95d-4e1a-9ebe-820dfd77ae61.png"
              alt="ChillWise Air Conditioning Systems Logo" 
              className="h-28 md:h-32"
            />
          </div>
          <div className="text-center space-y-4 opacity-0 animate-fadeIn">
            <div className="inline-block px-3 py-1 rounded-full bg-chillwise/10 text-sm font-medium text-chillwise mb-2">
              Profesjonalna klimatyzacja
            </div>
            <h1 className="text-3xl md:text-5xl font-bold tracking-tight text-chillwise-dark">
              Wycena klimatyzacji dla Twojego mieszkania
            </h1>
            <p className="text-gray-600 max-w-2xl mx-auto text-lg">
              Oblicz koszt instalacji klimatyzacji w Twoim mieszkaniu. 
              Przedstawimy Ci dwie oferty dopasowane do Twoich potrzeb.
            </p>
          </div>
        </div>
      </header>
      
      {/* Main Content */}
      <main className="flex-grow w-full px-6 pb-16">
        <div className="max-w-6xl mx-auto">
          <PriceCalculator />
          
          {/* Additional Info */}
          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 opacity-0 animate-fadeIn animate-delay-200">
            <div className="glass-card p-6 space-y-3">
              <h3 className="font-semibold text-lg text-chillwise-dark">Profesjonalny montaż</h3>
              <p className="text-gray-600">
                Zapewniamy fachową instalację przez certyfikowanych techników z wieloletnim doświadczeniem.
              </p>
            </div>
            
            <div className="glass-card p-6 space-y-3">
              <h3 className="font-semibold text-lg text-chillwise-dark">Gwarancja jakości</h3>
              <p className="text-gray-600">
                Wszystkie nasze urządzenia posiadają pełną gwarancję producenta oraz serwis na terenie całej Polski.
              </p>
            </div>
            
            <div className="glass-card p-6 space-y-3">
              <h3 className="font-semibold text-lg text-chillwise-dark">Bezpłatna konsultacja</h3>
              <p className="text-gray-600">
                Po wybraniu oferty, nasz ekspert skontaktuje się z Tobą, aby omówić szczegóły i odpowiedzieć na pytania.
              </p>
            </div>
          </div>
        </div>
      </main>
      
      {/* Footer */}
      <footer className="w-full bg-white py-6 border-t border-gray-200">
        <div className="max-w-6xl mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-500">
            <div className="flex items-center mb-4 md:mb-0">
              <img 
                src="/logos/17592c35-a95d-4e1a-9ebe-820dfd77ae61.png"
                alt="ChillWise Air Conditioning Systems Logo" 
                className="h-8 mr-3"
              />
              <p>© 2025 ChillWise. Wszelkie prawa zastrzeżone.</p>
            </div>
            <div className="mt-4 md:mt-0">
              <a href="#" className="mx-2 hover:text-chillwise transition-colors">Polityka prywatności</a>
              <a href="#" className="mx-2 hover:text-chillwise transition-colors">Regulamin</a>
              <a href="#" className="mx-2 hover:text-chillwise transition-colors">Kontakt</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Index;
